// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Collection = M.Collection || {};
M.Collection.ProductDetails = M.Collection.ProductDetails || {};

/**
 * @class M.Collection.ProductDetails.Accessories
 *
 * Used by by the M.View.ProductDetails.AccessoryPicker
 */
M.Collection.ProductDetails.Accessories = Backbone.Collection.extend({
  model: M.Model.ProductDetails.Accessory,

  /**
   * @param accessory {Accessory} The Accessory model to select.
   */
  select: function(accessory) {
    this.selected = accessory;
  },

  /**
   * Selects an accessory in the collection and returns the selected model.
   *
   * @param sku {Accessory.sku}
   * @return {Accessory}
   */
  selectBySku: function(sku) {
    var that = this;
    _.each(this.models, function(model) {
      if (model.get('sku') == sku) {
        that.selected = model;
      }
    });
    this.trigger('selected_sku');
    return this.selected;
  },

  /**
   * Return the selected accessory.
   *
   * @return this.selcted {Accessory} The selected Accessory model.
   */
  getSelected: function() {
    return this.selected;
  }
});
